import React from 'react';

import DocsTemplate from 'src/templates/DocsTemplate/DocsTemplate';
import SideNav from 'src/components/navigation/sidenav';
import Contentcard from 'src/components/content-cards';
import FeatureSectionItem from 'src/components/features/feature-section-item';
import {
  DeEndUserPrivacyPolicy,
  FrEndUserPrivacyPolicy,
  EnEndUserPrivacyPolicy,
  EsEndUserPrivacyPolicy,
  NlEndUserPrivacyPolicy,
} from 'src/components/Legal/EndUserPrivacyPolicy';

import {
  DePrivacyStatement,
  EnPrivacyStatement,
  EsPrivacyStatement,
  FrPrivacyStatement,
  NlPrivacyStatement,
} from 'src/components/Legal/PrivacyStatement';

import {
  DeCookiePolicy,
  EnCookiePolicy,
  EsCookiePolicy,
  FrCookiePolicy,
  NlCookiePolicy,
} from 'src/components/Legal/CookiePolicy';

import {
  USEndUserServicesAgreement,
  UKEndUserServicesAgreement,
  EEANLEndUserServicesAgreement,
  EEAEndUserServicesAgreement,
  EWRDEEndUserServicesAgreement,
} from 'src/components/Legal/EndUserServicesAgreement';

import SMSTerms from 'src/components/Legal/SMSTerms';

import {
  EnDeveloperPolicy,
  FrDeveloperPolicy,
  EsDeveloperPolicy,
  DeDeveloperPolicy,
} from 'src/components/Legal/DeveloperPolicy';

import {
  EnCandidatePrivacyNotice,
  FrCandidatePrivacyNotice,
  NlCandidatePrivacyNotice,
  DeCandidatePrivacyNotice,
} from 'src/components/Legal/CandidatePrivacyNotice';

import EnIDVPrivacyStatement from 'src/components/Legal/IDVPrivacyStatement/EnVersion';
import FrIDVPrivacyStatement from 'src/components/Legal/IDVPrivacyStatement/FrVersion';
import EsIDVPrivacyStatement from 'src/components/Legal/IDVPrivacyStatement/EsVersion';
import PtIDVPrivacyStatement from 'src/components/Legal/IDVPrivacyStatement/PtVersion';
import JaIDVPrivacyStatement from 'src/components/Legal/IDVPrivacyStatement/JaVersion';

import EnBiometricPolicyAndRelease from 'src/components/Legal/BiometricPolicyAndRelease/EnVersion';
import FrBiometricPolicyAndRelease from 'src/components/Legal/BiometricPolicyAndRelease/FrVersion';
import EsBiometricPolicyAndRelease from 'src/components/Legal/BiometricPolicyAndRelease/EsVersion';

import LegalChangelog from 'src/components/Legal/LegalChangelog';
import { ModernSlaveryActTransparencyStatement } from 'src/components/Legal';
import { Link } from 'src/components/Inputs';
import ArrowDown from 'src/components/SVGs/Icons/ArrowDown';

import {
  metaData,
  sideNavData,
  getStartedData,
  endUserPrivacyPolicyData,
  privacyStatementData,
  cookiePolicyData,
  developerPolicyData,
  candidatePrivacyNoticeData,
  plaidAccountTermsData,
  idvPrivacyStatementData,
  biometricPolicyData,
} from '../store/legal';
import { Locales } from 'src/lib/constants';
import ModulrTermsGB from 'src/components/Legal/modulr-terms-gb';
import ModulrTermsEU from 'src/components/Legal/modulr-terms-eu';
import EnPlaidAccountTerms from 'src/components/Legal/PlaidAccountTerms/EnPlaidAccountTerms';
import FrPlaidAccountTerms from 'src/components/Legal/PlaidAccountTerms/FrPlaidAccountTerms';

const Legal = ({ locale = Locales.EN_US }) => {
  return (
    <DocsTemplate {...metaData} locale={locale}>
      <nav id='docsSubnav' className='subnav subnav-sticky'>
        <div className='subnav-inner'>
          <ul className='menu subnav-links show-for-large'>
            <li className='is-active'>
              <Link href='/legal'>
                <a>Legal</a>
              </Link>
            </li>
          </ul>

          <div className='subnav-links__center show-for-large'>
            <p>
              <Link href='mailto:legalnotices@plaid.com'>
                <a>Contact us</a>
              </Link>
            </p>
          </div>

          <ul className='menu subnav-links hide-for-large'>
            <li className='subnav-links-item' data-toggle='subnavDropdown'>
              <a>
                Legal
                <span className='subnav-link-dropdown-arrow' aria-hidden='true'>
                  <ArrowDown />
                </span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <div
        className='subnav-dropdown dropdown-pane hide-for-large'
        id='subnavDropdown'
        data-dropdown
      >
        <SideNav id='mobileSidenavMenu' items={sideNavData} />
      </div>

      <div className='bg-docs legal'>
        <div id='docsWrapper' className='grid-container'>
          <div className='grid-x'>
            <aside id='docsSidenav' className='cell large-3 sidenav-docs'>
              <div
                className='sticky show-for-large'
                data-sticky
                data-top-anchor='docsSidenav:top'
                data-btm-anchor='footer:top'
                data-margin-top='16'
                data-margin-bottom='1'
                data-check-every='0'
              >
                <SideNav id='desktopSidenavMenu' items={sideNavData} />
              </div>
            </aside>
            <article
              id='docsArticle'
              className='cell small-12 large-auto article-docs'
            >
              <div className='article-docs-content'>
                <div className='overview-section'>
                  <h2 id='overview' data-magellan-target='overview'>
                    Overview
                  </h2>

                  <Contentcard {...getStartedData.contentCards} />
                  {getStartedData.featureListItems.map((featureItem, i) => {
                    return (
                      <FeatureSectionItem
                        {...featureItem}
                        key={`featureItem-${i}`}
                      />
                    );
                  })}
                </div>

                <hr className='section-divider' />

                <h2 id='consumers'>End Users</h2>

                <EnEndUserPrivacyPolicy
                  availableLanguages={
                    endUserPrivacyPolicyData.availableLanguages.en
                  }
                />
                <FrEndUserPrivacyPolicy
                  availableLanguages={
                    endUserPrivacyPolicyData.availableLanguages.fr
                  }
                />
                <EsEndUserPrivacyPolicy
                  availableLanguages={
                    endUserPrivacyPolicyData.availableLanguages.es
                  }
                />
                <NlEndUserPrivacyPolicy
                  availableLanguages={
                    endUserPrivacyPolicyData.availableLanguages.nl
                  }
                />
                <DeEndUserPrivacyPolicy
                  availableLanguages={
                    endUserPrivacyPolicyData.availableLanguages.de
                  }
                />
                <USEndUserServicesAgreement />
                <UKEndUserServicesAgreement />
                <EEAEndUserServicesAgreement />
                <EEANLEndUserServicesAgreement />
                <EWRDEEndUserServicesAgreement />

                <SMSTerms />

                <EnPlaidAccountTerms
                  availableLanguages={
                    plaidAccountTermsData.availableLanguages.en
                  }
                />
                <FrPlaidAccountTerms
                  availableLanguages={
                    plaidAccountTermsData.availableLanguages.fr
                  }
                />

                <EnIDVPrivacyStatement
                  availableLanguages={
                    idvPrivacyStatementData.availableLanguages.en
                  }
                />
                <FrIDVPrivacyStatement
                  availableLanguages={
                    idvPrivacyStatementData.availableLanguages.fr
                  }
                />
                <EsIDVPrivacyStatement
                  availableLanguages={
                    idvPrivacyStatementData.availableLanguages.es
                  }
                />
                <PtIDVPrivacyStatement
                  availableLanguages={
                    idvPrivacyStatementData.availableLanguages.pt
                  }
                />
                <JaIDVPrivacyStatement
                  availableLanguages={
                    idvPrivacyStatementData.availableLanguages.ja
                  }
                />

                <EnBiometricPolicyAndRelease
                  availableLanguages={biometricPolicyData.availableLanguages.en}
                />
                <FrBiometricPolicyAndRelease
                  availableLanguages={biometricPolicyData.availableLanguages.fr}
                />
                <EsBiometricPolicyAndRelease
                  availableLanguages={biometricPolicyData.availableLanguages.es}
                />

                <h2 id='developers'>Developers</h2>
                <EnDeveloperPolicy
                  availableLanguages={developerPolicyData.availableLanguages.en}
                />
                <FrDeveloperPolicy
                  availableLanguages={developerPolicyData.availableLanguages.fr}
                />
                <EsDeveloperPolicy
                  availableLanguages={developerPolicyData.availableLanguages.es}
                />
                <DeDeveloperPolicy
                  availableLanguages={developerPolicyData.availableLanguages.de}
                />

                <ModulrTermsEU />
                <ModulrTermsGB />

                <h2 id='job-candidates'>Job Candidates</h2>
                <EnCandidatePrivacyNotice
                  availableLanguages={
                    candidatePrivacyNoticeData.availableLanguages.en
                  }
                />
                <FrCandidatePrivacyNotice
                  availableLanguages={
                    candidatePrivacyNoticeData.availableLanguages.fr
                  }
                />
                <NlCandidatePrivacyNotice
                  availableLanguages={
                    candidatePrivacyNoticeData.availableLanguages.nl
                  }
                />
                <DeCandidatePrivacyNotice
                  availableLanguages={
                    candidatePrivacyNoticeData.availableLanguages.de
                  }
                />

                <h2 id='all-audiences'>All Audiences</h2>
                <EnPrivacyStatement
                  availableLanguages={
                    privacyStatementData.availableLanguages.en
                  }
                />
                <DePrivacyStatement
                  availableLanguages={
                    privacyStatementData.availableLanguages.de
                  }
                />
                <EsPrivacyStatement
                  availableLanguages={
                    privacyStatementData.availableLanguages.es
                  }
                />
                <FrPrivacyStatement
                  availableLanguages={
                    privacyStatementData.availableLanguages.fr
                  }
                />
                <NlPrivacyStatement
                  availableLanguages={
                    privacyStatementData.availableLanguages.nl
                  }
                />
                <EnCookiePolicy
                  availableLanguages={cookiePolicyData.availableLanguages.en}
                />
                <DeCookiePolicy
                  availableLanguages={cookiePolicyData.availableLanguages.de}
                />
                <EsCookiePolicy
                  availableLanguages={cookiePolicyData.availableLanguages.es}
                />
                <FrCookiePolicy
                  availableLanguages={cookiePolicyData.availableLanguages.fr}
                />
                <NlCookiePolicy
                  availableLanguages={cookiePolicyData.availableLanguages.nl}
                />
                <ModernSlaveryActTransparencyStatement id='msats' />
                <LegalChangelog id='legal-changelog' />
              </div>
            </article>
          </div>
        </div>
      </div>
    </DocsTemplate>
  );
};

export default Legal;
